import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { extendObservable } from 'mobx'
import PropTypes from 'prop-types'

import ChevronIcon from '@components/icons/ChevronIcon'

class CollapsibleFilterGroup extends Component {
  static propTypes = {
    open: PropTypes.bool,
    title: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
  }

  constructor (props) {
    super(props)
    extendObservable(this, {
      open: props.open
    })
  }

  render () {
    const { title, children } = this.props
    return (
      <div className='search-group'>
        <div className='clickable' onClick={() => (this.open = !this.open)}>
          <div className='pull-right'>
            {this.open ? <ChevronIcon up /> : <ChevronIcon down />}
          </div>
          <h4>{title}</h4>
        </div>
        {this.open ? <div className='content'>{children}</div> : ''}
      </div>
    )
  }
}

export default observer(CollapsibleFilterGroup)
